import React from 'react';
import PropTypes from 'prop-types';

import './EmployerPageLayout.scss';
import Layout from '../../../Layout/Layout';
import BottomBanner from '../../Marketing/BottomBanner/BottomBanner';
import EmployerMarketingSubnav from '../../Marketing/EmployerMarketingSubnav/EmployerMarketingSubnav';
import { PageContext } from '../../../../contexts/ContextCreator';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

export default class EmployerPageLayout extends React.PureComponent {
    constructor(props) {
        super(props);
        this.baseClassName = 'component-Employer-Layout-EmployerPageLayout';
    }

    static propTypes = {
        /**
         * global page props
         */
        PAGE_PROPS: PropTypes.object,
        /**
         * additional styling
         */
        className: PropTypes.string,
        hasChangingContainer: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        hasChangingContainer: true,
    };

    static contextType = PageContext;

    handleDemoButtonClick = (eventType) => () => {
        const { modalTrigger } = this.context;
        modalTrigger('EmployerClaimForm');

        if (eventType) {
            EmitMetric({
                misc_event_type: eventType,
                misc_event_count: 1,
            });
        }
    };

    render() {
        const { children, className, PAGE_PROPS } = this.props;

        return (
            <Layout
                className={`${this.baseClassName} ${className}`}
                PAGE_PROPS={PAGE_PROPS}
                topBannerExclusionList={['community-onboard']}
                hasChangingContainer={this.props.hasChangingContainer}
            >
                <EmployerMarketingSubnav
                    handleDemoButtonClick={this.handleDemoButtonClick(
                        'employer-marketing-nav-demo-click'
                    )}
                />

                <div className={`${this.baseClassName}__content`}>
                    {typeof children === 'function'
                        ? children({
                              handleDemoButtonClick: this.handleDemoButtonClick,
                          })
                        : React.Children.map(children, (child) =>
                              React.cloneElement(child, {
                                  handleDemoButtonClick: this
                                      .handleDemoButtonClick,
                              })
                          )}
                </div>

                <BottomBanner
                    button={{
                        onClick: this.handleDemoButtonClick(
                            'employer-marketing-footer-demo-click'
                        ),
                        text: 'Learn more',
                    }}
                    text={
                        'Connect with the largest career community for women.'
                    }
                />
            </Layout>
        );
    }
}
